<div class="olb-login-alert-notification" *ngIf="alertTextFromJSON">
    <div class="container-1024-1480">
        <span class="message" [innerHTML]="textToDisplay"></span>
        <span *ngIf="(stringLengthWithoutHTML > allowedLength)">
            <span *ngIf="(!this.expandView)">...
                <span (click)="toggleText()" class="info-text-color" >{{OLB_TXT_0292_MoreInfo}}</span>
            </span>
            <span *ngIf="(this.expandView)"(click)="toggleText()" class="info-text-color">{{OLB_TXT_0312_LessInfo}}
            </span>
            <span class="expand-button" (click)="toggleText()">
                <img [src]="'img/caret-up.png' | assetsContext" [class.carret_down]="expandView"
                    [class.carret_up]="!expandView">
            </span>
        </span>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/loginalert/loginalert.component.html